import React, { memo, ReactElement, ReactNode } from "react";
import classNames from "classnames";
import { withStyles } from "@swiggy-private/core-ui";
import styles from "./styles.scss";
import { COMMON_HEADER_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface CommonHeaderContentProps {
    title: ReactNode;
    subtitle?: ReactNode;
    grayscale?: boolean;
    handleTitleClick?(): void;
}

function CommonHeaderContent(props: CommonHeaderContentProps): ReactElement {
    const { title, subtitle, grayscale = false, handleTitleClick = (): void => undefined } = props;
    const subtitleClass = classNames(styles.headerSubtitle, {
        [styles.headerSubtitleGray]: grayscale,
    });
    const titleClass = classNames(styles.headerTitle, styles.headerTitleCartV2);
    return (
        <div className={styles.header}>
            <button
                className={titleClass}
                data-testid={COMMON_HEADER_TEST_IDS.RESTAURANT_NAME}
                onClick={handleTitleClick}
            >
                {title}
            </button>
            {props.subtitle && <div className={subtitleClass}>{subtitle}</div>}
        </div>
    );
}

export default memo(withStyles(CommonHeaderContent, styles));
